let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4KjiR")).then(() => parcelRequire('5Wn3P'));